import { MetaPager } from '@/types/API.type'
import { MemberEventsRaw, MemberForAdmin, MemberSingle } from '@/types/Member.type'
import { MyPendingSuggestionResponse } from '@/types/response/MyPendingSuggestionResponse.type'
import { PendingRelationshipSuggestionForMemberResponse } from '@/types/response/PendingRelationshipSuggestionForMemberResponse.type'

export type State = {
    pendingRelationshipSuggestionList: MyPendingSuggestionResponse
    pendingRelationshipSuggestionListPager: MetaPager | null
    favoriteMemberList: any
    contactMemberList: any
    sameEventsMemberList: any
    sortMemberListBy: any
    searchedMemberList: any
    searchFilters: any
    searchFiltersSelected: any
    loading: any
    nationalityList: any
    languageList: any
    pendingRelationshipSuggestion: PendingRelationshipSuggestionForMemberResponse | null
    memberSingle: {
        member: MemberSingle | null
        memberForAdmin: MemberForAdmin | null
        memberEvents: MemberEventsRaw | null
    }
}

const state = (): State => ({
    pendingRelationshipSuggestionList: [],
    pendingRelationshipSuggestionListPager: null,
    pendingRelationshipSuggestion: null, // Pending suggestion on profile
    favoriteMemberList: {
        currentPage: null,
        nbResults: null,
        results: [],
    },
    contactMemberList: {
        currentPage: null,
        nbResults: null,
        results: [],
    },
    sameEventsMemberList: [],
    sortMemberListBy: 'scoring',
    searchedMemberList: {
        currentPage: null,
        nbResults: null,
        results: [],
    },
    searchFilters: [],
    searchFiltersSelected: {},
    loading: {
        pendingSuggestionList: false,
        searchedMemberList: false,
        searchFilters: false,
        contactMemberList: false,
        favoriteMemberList: false,
        sameEventsMemberList: false,
    },
    nationalityList: [],
    languageList: [],
    memberSingle: {
        member: null,
        memberForAdmin: null,
        memberEvents: null,
    },
})

export default state
